import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class DashboardRoute extends Route {
  @service router;
  @service session;

  get controllerName() {
    return this.session.currentUser?.isSeller
      ? 'dashboard.seller-dashboard'
      : 'dashboard.buyer-dashboard';
  }

  get templateName() {
    return this.session.currentUser?.isSeller
      ? 'dashboard.seller-dashboard'
      : 'dashboard.buyer-dashboard';
  }

  redirect() {
    if (this.session.currentUser.isAdmin) {
      this.router.replaceWith('admin.users');
    }
  }

  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/dashboard/');
  }

  /** @inheritDoc */
  setupController(controller) {
    controller.bootstrapPage.perform();
  }

  /** @inheritDoc */
  resetController(controller) {
    controller.bootstrapPage.cancelAll({ resetState: true });
    controller.getLatestSupportArticle.cancelAll({ resetState: true });
    controller.loadModuleData.cancelAll({ resetState: true });

    controller.setProperties({
      actionItems: [],
      latestSupportArticle: null,
    });

    if (this.session.currentUser.isSeller) {
      controller.getUser.cancelAll({ resetState: true });
      controller.loadCampaign.cancelAll({ resetState: true });
      controller.set('user', null);
    }

    else {
      controller.getCompany.cancelAll({ resetState: true });
      controller.getLatestBlogPost.cancelAll({ resetState: true });

      controller.setProperties({
        company: null,
        latestBlogPost: null,
      });
    }
  }
}

export default DashboardRoute;
